const catalogMenu = document.querySelector('.catalog-menu');
let itemsArray = [];

if (catalogMenu) {
  const activeParentItems = finActiveItem();

  Array.from(activeParentItems).forEach(elem => elem.classList.add('opened'));

  catalogMenu.addEventListener('click', function (evt) {
    const elem = evt.target;
    if (elem.closest('.catalog-menu__svg')) {
      evt.preventDefault();
      toggleSubmenu(elem);
    }
  });
}

function toggleSubmenu(elem) {
  const arrow = elem;
  const parent = arrow.closest('li');
  if (parent.classList.contains('opened')) {
    parent.classList.remove(`opened`);
  } else {
    parent.classList.add(`opened`);
  }
}

function finActiveItem() {
  const elem = catalogMenu.querySelector('.active');
  if (elem) {
    return findAllParentItems(elem);
  }
  return [];
}

function findAllParentItems(elem) {
  if (elem.closest('li')) {
    const item = elem.parentElement.parentElement;
    if (item.nodeName !== 'LI') {
      return itemsArray;
    } else {
      itemsArray.push(item);
      return findAllParentItems(item);
    }
  } else {
    return itemsArray;
  }
}
